<svelte:options tag={null} />
<script>
  import { get_current_component } from "svelte/internal";
  import { formatNumbers } from '@everymatrix/retail-helpers';
  import "@everymatrix/em-accordion";

  export let limits = null;
  export let currency = '';
  export let isedit = false;
  export let isloading = false;

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleDelete = (period) => {
    // Send Custom Event
    let endpoint = `limits/wagering?periods=${period}`;
    dispatchWcEvent("delete", { endpoint, limit: 'wagering' });
  };
</script>
{#if limits}
<div class="activeLimit">
  <ul class="activeLimit__list">
    <li class="activeLimit__title">
      Wagering Limit
    </li>
    {#each limits as limit}
      <li class="activeLimit__limit" class:modified={limit.isModified}>
        <div class="activeLimit__content" class:modified={limit.isModified}>
          {#if isedit && limit.expiryDate.substr(1, 3) === '999'}
            <button 
              class="activeLimit__delete"
              on:click={() => handleDelete(limit.period)}
            > 
              {#if isloading}
                <div class="sk-chase">
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                </div>
              {:else}
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
              {/if}
            </button>
          {/if}
          <strong>{limit.period}:</strong>
          {formatNumbers(limit.amount)} {currency}
        </div>
          <!-- Updated Date -->
          {#if limit.updateAmount > 0 && limit.updateAmount !== limit.amount && limit.isModified}
          <p class="activeLimit__expiry">
            <strong>Limit has been modified:</strong> 
            {formatNumbers(limit.updateAmount)} seconds
          </p>
          <p class="activeLimit__expiry">
            <strong>Valid until:</strong> 
            {limit.expiryDate}
          </p>
        {/if}
        <!-- Expiry Date -->
        {#if 
          limit.updateAmount === -1 &&
          limit.isModified
        }
          <p class="activeLimit__expiry">
            <strong>Removed and valid until:</strong>
            {limit.expiryDate}
          </p>
        {/if}
      </li>
    {/each}
  </ul>
</div>
{/if}

<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  
  .activeLimit {
    margin-bottom: 10px;

    &__list {
      margin-bottom: 15px;
    }

    &__title {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    &__limit {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      margin-bottom: 5px;
      &:last-child { margin-bottom: 0; }

      strong {
        font-size: 12px;
      }

      &.modified {
        padding-left: 5px;
        border-left: 4px solid green;
      }
    }

    &__content {
      display: grid;
      grid-template-columns: auto auto 1fr;
      gap: 5px;
      align-items: center;
      border-left: 4px solid gray;
      padding-left: 5px;
      font-size: 14px;
      &.modified { border: none; }
    }

    &__delete {
      display: flex;
      width: 25px;
      height: 25px;
      padding: 5px;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      svg { fill: #868686; }
      &:hover {
        svg { fill: #ec7777; }
      }
    }

    &__expiry {
      margin: 5px 0;
      font-size: 12px;
      color: green;
      strong { 
        margin-right: 0px;
        font-size: 12px;
      }
    }
  }

  .sk-chase {
    width: 10px;
    height: 10px;
    position: relative;
    left: 2px;
    top: 2px;
    animation: sk-chase 2.5s infinite linear both;
  }

  .sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0; 
    animation: sk-chase-dot 2.0s infinite ease-in-out both; 
  }

  .sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: green;
    border-radius: 100%;
    animation: sk-chase-dot-before 2.0s infinite ease-in-out both; 
  }

  .sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
  .sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
  .sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
  .sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
  .sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
  .sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
  .sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

  @keyframes sk-chase {
    100% { transform: rotate(360deg); } 
  }

  @keyframes sk-chase-dot {
    80%, 100% { transform: rotate(360deg); } 
  }

  @keyframes sk-chase-dot-before {
    50% {
      transform: scale(0.4); 
    } 100%, 0% {
      transform: scale(1.0); 
    } 
  }
</style>
